import { Button } from '@/lib/Buttons';
import { TranslationKeys } from '@/localization';
import { toRuntimeTranslationKey } from '@/localization/translationKey';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type SuccessModalFooterProps = {
  onConfirm: () => Promise<void>;
  isLoading?: boolean;
  confirmText?: TranslationKeys;
};

export const SuccessModalFooter: FC<SuccessModalFooterProps> = ({ onConfirm, isLoading = false, confirmText = 'COMMON.gotIt' }) => {
  const { t } = useTranslation();
  const confirmTextKey = toRuntimeTranslationKey(confirmText);

  return <Button text={t(confirmTextKey as any)} onClick={onConfirm} size='lg' className='size-full' isLoading={isLoading} />;
};
